/* ================================================
   PRODUCT PAGE - INTERACTIVE ELEMENTS
   ================================================ */

/**
 * Inventory Status Component
 * Updates inventory status display when variant changes
 * Uses pub/sub pattern to listen for variant changes
 */
if (!customElements.get('inventory-status')) {
  customElements.define(
    'inventory-status',
    class InventoryStatus extends HTMLElement {
      constructor() {
        super();
        this.handleVariantChange = this.handleVariantChange.bind(this);
      }

      connectedCallback() {
        // En este tema, product.js usa eventos nativos de document
        document.addEventListener('variant:updated', this.handleVariantChange);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:updated', this.handleVariantChange);
      }

      handleVariantChange(event) {
        const variant = event.detail.variant;
        const sectionId = this.dataset.sectionId;
        
        if (!variant || !sectionId) return;

        // Como product.js no refresca el HTML completo, lo pedimos al servidor
        // para obtener el resultado de la lógica de Liquid (warehouse stocks)
        fetch(`${window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newInventoryStatus = html.querySelector(
              `inventory-status[data-section-id="${sectionId}"]`
            );

            if (newInventoryStatus) {
              this.innerHTML = newInventoryStatus.innerHTML;

            //   console.group('Inventory Status Updated - Variant Change');
            //   console.log('Variant ID:', variant.id);
            //   console.log('Status Updated from Server');
            //   console.groupEnd();
            }
          })
          .catch((e) => console.error('Error updating inventory status:', e));
      }
    }
  );
}


(function () {
    'use strict';

    // ===== PRODUCT GALLERY CAROUSEL =====

    /**
     * Initialize product gallery with thumbnail navigation
     */
    function initProductGallery() {
        const thumbnails = document.querySelectorAll('.thumbnail-btn, .thumbnail-item');
        const mainImage = document.getElementById('main-product-image');
        const prevBtn = document.querySelector('.gallery-prev-btn');
        const nextBtn = document.querySelector('.gallery-next-btn');
        const thumbnailsContainer = document.querySelector('.gallery-thumbnails');

        if (!thumbnails.length || !mainImage) return;

        let currentIndex = 0;
        let isDragging = false;
        let startX;
        let scrollLeft;

        /**
         * Update navigation buttons visibility
         */
        function updateNavButtons() {
            if (prevBtn) {
                if (currentIndex === 0) {
                    prevBtn.classList.add('hidden');
                } else {
                    prevBtn.classList.remove('hidden');
                }
            }

            if (nextBtn) {
                if (currentIndex === thumbnails.length - 1) {
                    nextBtn.classList.add('hidden');
                } else {
                    nextBtn.classList.remove('hidden');
                }
            }
        }

        /**
         * Change to specific image index
         */
        function changeImage(index) {
            if (index < 0 || index >= thumbnails.length) return;

            currentIndex = index;
            const thumbnail = thumbnails[index];
            const newImageSrc = thumbnail.getAttribute('data-image') || thumbnail.querySelector('img')?.src;

            if (!newImageSrc) return;

            // Fade out effect
            mainImage.style.opacity = '0';

            // Change image after fade out
            setTimeout(function () {
                mainImage.src = newImageSrc;
                mainImage.style.opacity = '1';
            }, 150);

            // Update active state
            thumbnails.forEach(function (btn, idx) {
                if (idx === index) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            });

            // Smooth scroll to active thumbnail
            scrollToThumbnail(index);

            // Update navigation buttons
            updateNavButtons();
        }

        /**
         * Scroll to specific thumbnail with smooth behavior
         */
        function scrollToThumbnail(index) {
            const targetThumbnail = thumbnails[index];

            if (!thumbnailsContainer || !targetThumbnail) return;

            // Use a small delay to ensure DOM is updated
            setTimeout(function () {
                // Get container dimensions
                const containerRect = thumbnailsContainer.getBoundingClientRect();
                const thumbnailRect = targetThumbnail.getBoundingClientRect();

                // Calculate how much to scroll to center the thumbnail
                const scrollOffset = (thumbnailRect.left - containerRect.left) +
                    (thumbnailRect.width / 2) -
                    (containerRect.width / 2);

                // Scroll to the calculated position
                thumbnailsContainer.scrollBy({
                    left: scrollOffset,
                    behavior: 'smooth'
                });
            }, 50);
        }

        /**
         * Initialize drag-to-scroll functionality
         */
        function initDragToScroll() {
            if (!thumbnailsContainer) return;

            // Mouse down event
            thumbnailsContainer.addEventListener('mousedown', function (e) {
                isDragging = true;
                thumbnailsContainer.classList.add('dragging');
                startX = e.pageX - thumbnailsContainer.offsetLeft;
                scrollLeft = thumbnailsContainer.scrollLeft;
            });

            // Mouse leave event
            thumbnailsContainer.addEventListener('mouseleave', function () {
                isDragging = false;
                thumbnailsContainer.classList.remove('dragging');
            });

            // Mouse up event
            thumbnailsContainer.addEventListener('mouseup', function () {
                isDragging = false;
                thumbnailsContainer.classList.remove('dragging');
            });

            // Mouse move event
            thumbnailsContainer.addEventListener('mousemove', function (e) {
                if (!isDragging) return;
                e.preventDefault();
                const x = e.pageX - thumbnailsContainer.offsetLeft;
                const walk = (x - startX) * 2; // Scroll speed multiplier
                thumbnailsContainer.scrollLeft = scrollLeft - walk;
            });

            // Prevent click when dragging
            thumbnails.forEach(function (thumbnail) {
                thumbnail.addEventListener('click', function (e) {
                    if (Math.abs(thumbnailsContainer.scrollLeft - scrollLeft) > 5) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            });
        }

        // Add click event to each thumbnail
        thumbnails.forEach(function (thumbnail, index) {
            thumbnail.addEventListener('click', function () {
                changeImage(index);
            });
        });

        // Previous button click
        if (prevBtn) {
            prevBtn.addEventListener('click', function () {
                if (currentIndex > 0) {
                    changeImage(currentIndex - 1);
                }
            });
        }

        // Next button click
        if (nextBtn) {
            nextBtn.addEventListener('click', function () {
                if (currentIndex < thumbnails.length - 1) {
                    changeImage(currentIndex + 1);
                }
            });
        }

        // Keyboard navigation for accessibility
        thumbnails.forEach(function (thumbnail, index) {
            thumbnail.addEventListener('keydown', function (e) {
                if (e.key === 'ArrowRight') {
                    const targetIndex = Math.min(index + 1, thumbnails.length - 1);
                    thumbnails[targetIndex].focus();
                    changeImage(targetIndex);
                } else if (e.key === 'ArrowLeft') {
                    const targetIndex = Math.max(index - 1, 0);
                    thumbnails[targetIndex].focus();
                    changeImage(targetIndex);
                }
            });
        });

        // Initialize drag-to-scroll
        initDragToScroll();

        // Initialize button state
        updateNavButtons();

        console.log('Product gallery initialized with ' + thumbnails.length + ' thumbnails');
    }

    // ===== PRODUCT DETAILS ACCORDION =====

    /**
     * Initialize product details accordion
     */
    function initProductAccordion() {
        const detailQuestions = document.querySelectorAll('.detail-question');

        if (!detailQuestions.length) return;

        detailQuestions.forEach(function (question) {
            question.addEventListener('click', function () {
                const answer = this.nextElementSibling;
                const isActive = this.classList.contains('active');

                // Toggle active state
                if (isActive) {
                    this.classList.remove('active');
                    answer.classList.remove('active');
                } else {
                    this.classList.add('active');
                    answer.classList.add('active');
                }
            });
        });

        console.log('Product accordion initialized with ' + detailQuestions.length + ' items');
    }

    // ===== VARIANT SELECTION MODULE =====

    /**
     * Variant Selection Handler
     * Manages product variant selection, UI updates, and form submission
     */
    const VariantSelector = {

        // DOM elements
        elements: {
            form: null,
            variantIdInput: null,
            optionInputs: [],
            addToCartBtn: null,
            priceRegular: null,
            priceCompare: null,
            availabilityText: null,
            quantityInput: null
        },

        // Product data
        product: null,

        // Current selected variant
        currentVariant: null,

        /**
         * Initialize the variant selector
         */
        init: function () {
            // Get product data
            this.product = window.productData;
            if (!this.product) {
                console.error('Product data not found. Make sure to include: <script>window.productData = {{ product | json }};</script>');
                return;
            }

            // Cache DOM elements
            this.cacheElements();

            // Set initial variant
            this.setInitialVariant();

            // Bind events
            this.bindEvents();

            console.log('Variant selector initialized for product:', this.product.title);
        },

        /**
         * Cache frequently used DOM elements
         */
        cacheElements: function () {
            this.elements.form = document.querySelector('.product-form');
            // More robust selector for variant ID input
            this.elements.variantIdInput = document.querySelector('input[name="id"]') || this.elements.form?.querySelector('input[name="id"]');
            this.elements.optionInputs = this.elements.form?.querySelectorAll('input[name^="options["], select[name^="options["]');
            this.elements.addToCartBtn = document.querySelector('.product-add-to-cart-btn');
            this.elements.priceRegular = document.querySelector('.price-regular');
            this.elements.priceCompare = document.querySelector('.price-compare');
            this.elements.availabilityText = document.querySelector('.availability-text');
            this.elements.quantityInput = document.querySelector('input[name="quantity"]');
            this.elements.skuDisplay = document.querySelector('.js-variant-sku');
            this.elements.skuWrapper = document.querySelector('.product-sku');

            // Debug logging
            console.log('DOM Elements cached:', {
                form: !!this.elements.form,
                variantIdInput: !!this.elements.variantIdInput,
                optionInputs: this.elements.optionInputs?.length || 0,
                addToCartBtn: !!this.elements.addToCartBtn,
                priceRegular: !!this.elements.priceRegular
            });
        },

        /**
         * Set the initial variant based on current selections or first available
         */
        setInitialVariant: function () {
            // Get current option values
            const selectedOptions = this.getSelectedOptions();

            // Find matching variant
            const variant = this.findVariantByOptions(selectedOptions);

            if (variant) {
                this.updateVariant(variant);
            } else {
                // Fallback to first available variant
                const firstAvailable = this.product.variants.find(v => v.available);
                if (firstAvailable) {
                    this.updateVariant(firstAvailable);
                }
            }
        },

        /**
         * Bind event listeners for option changes
         */
        bindEvents: function () {
            if (!this.elements.optionInputs.length) return;

            this.elements.optionInputs.forEach(input => {
                input.addEventListener('change', (e) => {
                    this.handleOptionChange(e);
                });
            });

            // Also listen for custom events if needed
            document.addEventListener('variant:change', (e) => {
                if (e.detail && e.detail.variant) {
                    this.updateVariant(e.detail.variant);
                }
            });
        },

        /**
         * Handle option input changes
         */
        handleOptionChange: function (event) {
            const input = event.target;

            console.log('🔄 Option changed:', { name: input.name, value: input.value, type: input.type });

            // Small delay to ensure all related inputs are updated
            setTimeout(() => {
                const selectedOptions = this.getSelectedOptions();
                console.log('📋 Selected options:', selectedOptions);

                const variant = this.findVariantByOptions(selectedOptions);
                console.log('🎯 Found variant:', variant ? { id: variant.id, price: variant.price, available: variant.available } : 'NONE');

                if (variant) {
                    this.updateVariant(variant);
                } else {
                    // No matching variant found
                    this.handleUnavailableCombination();
                }
            }, 10);
        },

        /**
         * Get current selected options as an object
         * @returns {Object} Selected options keyed by option name
         */
        getSelectedOptions: function () {
            const selectedOptions = {};

            this.elements.optionInputs.forEach(input => {
                const optionName = input.name.replace('options[', '').replace(']', '');

                if (input.type === 'radio' || input.type === 'checkbox') {
                    if (input.checked) {
                        selectedOptions[optionName] = input.value;
                    }
                } else if (input.tagName === 'SELECT') {
                    selectedOptions[optionName] = input.value;
                }
            });

            return selectedOptions;
        },

        /**
         * Find variant that matches the selected options
         * @param {Object} selectedOptions - Selected options object
         * @returns {Object|null} Matching variant or null
         */
        findVariantByOptions: function (selectedOptions) {
            return this.product.variants.find(variant => {
                // Check if this variant matches all selected options
                return this.product.options.every((option, index) => {
                    const optionName = option;
                    const selectedValue = selectedOptions[optionName];
                    const variantValue = variant.options[index];

                    return selectedValue === variantValue;
                });
            }) || null;
        },

        /**
         * Update the current variant and UI
         * @param {Object} variant - The selected variant object
         */
        updateVariant: function (variant) {
            this.currentVariant = variant;

            console.log('🔄 Updating variant:', {
                id: variant.id,
                title: variant.title,
                price: variant.price,
                available: variant.available
            });

            // Update hidden input (CRITICAL - must happen first)
            this.updateVariantIdInput(variant.id);

            // Update price display
            this.updatePriceDisplay(variant);

            // Update availability and button
            this.updateAvailability(variant);

            // Update SKU display
            this.updateSku(variant);

            // Update URL (optional)
            this.updateUrl(variant.id);

            // Dispatch custom event for other modules
            document.dispatchEvent(new CustomEvent('variant:updated', {
                detail: { variant: variant }
            }));

            console.log('✅ Variant update completed for ID:', variant.id);
        },

        /**
         * Update the hidden variant ID input
         * @param {number} variantId - The variant ID
         */
        updateVariantIdInput: function (variantId) {
            // Try multiple selectors to find the variant ID input
            let inputElement = this.elements.variantIdInput ||
                document.querySelector('input[name="id"]') ||
                document.querySelector('.product-form input[name="id"]');

            if (inputElement) {
                const oldValue = inputElement.value;
                inputElement.value = variantId;
                console.log('✅ Variant ID updated:', { oldValue, newValue: inputElement.value, variantId });
            } else {
                console.error('❌ Variant ID input not found! Available inputs:', document.querySelectorAll('input'));
            }
        },

        /**
         * Update price display elements
         * @param {Object} variant - The variant object
         */
        updatePriceDisplay: function (variant) {
            // Find price elements with multiple selectors
            const priceRegular = this.elements.priceRegular ||
                document.querySelector('.price-regular') ||
                document.querySelector('.product-price .price-regular');

            if (priceRegular) {
                const formattedPrice = this.formatMoney(variant.price);
                priceRegular.textContent = formattedPrice;
                console.log('✅ Price updated:', { variantPrice: variant.price, formattedPrice });
            } else {
                console.error('❌ Price element not found!');
            }

            // Handle compare at price
            const priceCompare = this.elements.priceCompare ||
                document.querySelector('.price-compare') ||
                document.querySelector('.product-price .price-compare');

            if (priceCompare) {
                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    const formattedComparePrice = this.formatMoney(variant.compare_at_price);
                    priceCompare.textContent = formattedComparePrice;
                    priceCompare.style.display = '';
                    console.log('✅ Compare price shown:', { comparePrice: variant.compare_at_price, formattedComparePrice });
                } else {
                    priceCompare.style.display = 'none';
                    console.log('ℹ️ Compare price hidden');
                }
            }
        },

        /**
         * Format money using Shopify's formatMoney or fallback
         * @param {number} cents - Price in cents
         * @returns {string} Formatted price string
         */
        formatMoney: function (cents) {
            // Try Shopify's formatMoney first
            if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                return Shopify.formatMoney(cents);
            }

            // Fallback to Intl.NumberFormat
            try {
                return new Intl.NumberFormat(window.Shopify?.locale || 'en-US', {
                    style: 'currency',
                    currency: window.Shopify?.currency?.active || 'USD'
                }).format(cents / 100);
            } catch (e) {
                // Last fallback - simple cents to dollars conversion
                return `$${(cents / 100).toFixed(2)}`;
            }
        },

        /**
         * Update availability status and add to cart button
         * @param {Object} variant - The variant object
         */
        updateAvailability: function (variant) {
            if (!this.elements.addToCartBtn) return;

            const isAvailable = variant.available;

            // Update button state
            this.elements.addToCartBtn.disabled = !isAvailable;
            this.elements.addToCartBtn.classList.toggle('disabled', !isAvailable);

            // Get translations with fallbacks
            const translations = window.variantStrings || {};
            const buttonText = isAvailable ?
                translations.addToCart || 'Add to cart' :
                (variant.id ? translations.soldOut || 'Sold out' : translations.unavailable || 'Unavailable');
            this.elements.addToCartBtn.textContent = buttonText;

            // Update availability text if present
            if (this.elements.availabilityText) {
                const availabilityText = isAvailable ?
                    translations.inStock || 'In stock' :
                    translations.outOfStock || 'Out of stock';
                this.elements.availabilityText.textContent = availabilityText;
                this.elements.availabilityText.classList.toggle('availability-text--out', !isAvailable);
            }

            console.log('🔄 Button updated:', { isAvailable, buttonText });
        },

        /**
         * Update the SKU display for the selected variant
         * @param {Object} variant - The variant object
         */
        updateSku: function (variant) {
            const skuDisplay = this.elements.skuDisplay || document.querySelector('.js-variant-sku');
            const skuWrapper = this.elements.skuWrapper || document.querySelector('.product-sku');

            if (!skuDisplay) return;

            if (variant.sku) {
                skuDisplay.textContent = variant.sku;
                if (skuWrapper) skuWrapper.style.display = '';
            } else {
                skuDisplay.textContent = '';
                if (skuWrapper) skuWrapper.style.display = 'none';
            }
        },

        /**
         * Handle unavailable variant combinations
         */
        handleUnavailableCombination: function () {
            console.warn('⚠️ No matching variant found for selected options');

            // Create a "dummy" unavailable variant for UI updates
            const unavailableVariant = {
                id: null,
                price: 0,
                compare_at_price: null,
                available: false,
                title: 'No disponible'
            };

            // Update UI to show unavailable state
            this.updatePriceDisplay(unavailableVariant);
            this.updateAvailability(unavailableVariant);

            // Don't update the variant ID input for unavailable combinations
            console.log('❌ Variant marked as unavailable - form will be disabled');
        },

        /**
         * Update URL with variant parameter (optional)
         * @param {number} variantId - The variant ID
         */
        updateUrl: function (variantId) {
            if (!variantId || !window.history.replaceState) return;

            const url = new URL(window.location);
            url.searchParams.set('variant', variantId);

            window.history.replaceState({}, '', url.toString());
        },

        /**
         * Get current variant
         * @returns {Object|null} Current variant object
         */
        getCurrentVariant: function () {
            return this.currentVariant;
        },

        /**
         * Get product data
         * @returns {Object} Product data object
         */
        getProduct: function () {
            return this.product;
        }
    };

    // ===== SIZE CHART MODAL FUNCTIONALITY =====

    /**
     * Initialize size chart modal functionality
     */
    function initSizeChartModal() {
        const sizeChartModal = document.getElementById('product-size-chart');
        const sizeChartLinks = document.querySelectorAll('.size-chart-link');
        const sizeChartClose = sizeChartModal ? sizeChartModal.querySelector('.size-chart-close') : null;
        const sizeChartOverlay = sizeChartModal ? sizeChartModal.querySelector('.size-chart-overlay') : null;

        if (!sizeChartModal || !sizeChartLinks.length) return;

        /**
         * Open size chart modal
         */
        function openSizeChartModal() {
            sizeChartModal.classList.add('active');
            document.body.classList.add('size-chart-modal-open');
        }

        /**
         * Close size chart modal
         */
        function closeSizeChartModal() {
            sizeChartModal.classList.remove('active');
            document.body.classList.remove('size-chart-modal-open');
        }

        // Add click event to all size chart links
        sizeChartLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                openSizeChartModal();
            });
        });

        // Close modal when clicking the close button
        if (sizeChartClose) {
            sizeChartClose.addEventListener('click', closeSizeChartModal);
        }

        // Close modal when clicking the overlay
        if (sizeChartOverlay) {
            sizeChartOverlay.addEventListener('click', closeSizeChartModal);
        }

        // Close modal with Escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && sizeChartModal.classList.contains('active')) {
                closeSizeChartModal();
            }
        });

        console.log('Size chart modal initialized');
    }

    // ===== SIZE CHART ACCORDION FUNCTIONALITY =====

    /**
     * Initialize size chart accordion functionality
     */
    function initSizeChartAccordion() {
        const sizeChartModal = document.getElementById('product-size-chart');
        if (!sizeChartModal) return;

        // Seleccionar todos los enlaces con data-toggle="collapse" dentro del modal
        const toggleLinks = sizeChartModal.querySelectorAll('a[data-toggle="collapse"]');
        
        if (!toggleLinks.length) return;

        toggleLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                
                // Obtener el target ID del href (ej: #ladies_guide)
                const targetId = this.getAttribute('href');
                if (!targetId || !targetId.startsWith('#')) return;
                
                // Buscar el elemento target
                const targetElement = sizeChartModal.querySelector(targetId);
                if (!targetElement) return;
                
                // Toggle la clase 'active' para mostrar/ocultar
                targetElement.classList.toggle('active');
            });
        });

        console.log('Size chart accordion initialized with ' + toggleLinks.length + ' toggle links');
    }

    // ===== INITIALIZE ON DOM READY =====

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initProductGallery();
            initProductAccordion();
            initSizeChartModal();
            initSizeChartAccordion();
            VariantSelector.init();
        });
    } else {
        initProductGallery();
        initProductAccordion();
        initSizeChartModal();
        initSizeChartAccordion();
        VariantSelector.init();
    }

    // Make VariantSelector available globally for debugging or other scripts
    window.VariantSelector = VariantSelector;

    // Debug helper function - can be called from browser console
    window.testVariantSelection = function () {
        console.log('🧪 Testing Variant Selection System:');
        console.log('Product data available:', !!window.productData);
        console.log('VariantSelector initialized:', !!window.VariantSelector);
        console.log('Current variant:', window.VariantSelector.getCurrentVariant());
        console.log('Form input value:', document.querySelector('input[name="id"]')?.value);
        console.log('Price element:', document.querySelector('.price-regular')?.textContent);
        console.log('Add to cart button:', document.querySelector('.product-add-to-cart-btn')?.textContent);
    };

})();

